module.exports = __webpack_public_path__ + "static/media/web.fe917bec.png";